@import '../../../node_modules/@cpt/pci/postnl-styles/settings';
@import '../../../node_modules/@cpt/pci/postnl-styles/04-layouts/containers';
@import '../../../node_modules/@cpt/pci/postnl-styles/tools/utilities';
@import '../../assets/styles/variables';
@import '../../assets/styles/typography';

:host(*) {
    all: initial;
    font-size: 16px;
    font-family: $font-family-bodytext, sans-serif;
}

.pnl-footer {
    font-family: $font-family-bodytext, sans-serif;
    background-color: $color-background-variant;
}

.pnl-footer__container {
    max-width: 1104px;
    padding: 0 1.5em;
    margin-inline: auto;

    @media (min-width: 681px) {
        padding: 0 2.5em;
    }

    @media (min-width: 1024px) {
        padding: 0 5.5em;
    }

    @media (min-width: 1281px) {
        padding: 0;
    }
}

.pnl-footer__list {
    display: flex;
    margin: 0;
    padding: 5em 0;
    list-style: none;
}

.pnl-footer__list--general {
    flex-direction: column;

    @media (min-width: 48em) {
        flex-direction: row;
        gap: 2.5em;
    }

    > .pnl-footer__listitem {
        &:not(:first-child) {
            @media (max-width: 48em) {
                padding-block-start: 1.5em;
            }
        }
    }
}

.pnl-footer__list--legal {
    margin-left: auto;
    flex-wrap: wrap;
    padding-block: 2.5em;

    @media (min-width: 48em) {
        flex-wrap: nowrap;
        align-items: center;
    }
}

.pnl-footer__list--nested {
    display: none;
    flex-direction: column;
    padding: 0.5em 0 0;

    @media (min-width: 48em) {
        display: block;
    }
}

.pnl-footer__list-title {
    display: none;
    position: relative;
    align-items: center;
    margin: 0;
    color: $color-body-text-default;
    font-size: 1rem;
    font-weight: 700;

    @media (min-width: 48em) {
        display: flex;
        margin: 0 0 0.5em;
    }
}

.pnl-footer__toggle-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border: 0;
    outline: 0;
    border-radius: 0.25em;
    padding: 0;
    background: transparent;
    color: $color-body-text-default;
    font-size: 1rem;
    font-weight: 700;

    @media (min-width: 48em) {
        display: none;
    }

    &:focus:not(:focus-visible) {
        outline: none;
    }

    &:focus-visible {
        outline-color: $color-border-focus-outline;
        outline-style: solid;
        outline-width: 2px;
        outline-offset: 3px;
    }

    @media (max-width: 48em) {
        &[aria-expanded='false'] + .pnl-footer__list--nested {
            display: none;
        }

        &[aria-expanded='true'] + .pnl-footer__list--nested {
            display: block;
        }
    }
}

.pnl-footer__toggle-icon {
    display: block;
    block-size: 1.5rem;
    inline-size: 1.5rem;

    > svg {
        color: $color-icon-default;
        width: 100%;
        height: 100%;
    }

    [aria-expanded='false'] & {
        transform: rotate(-180deg);
    }
}

.pnl-footer__list--nested .pnl-footer__listitem {
    display: flex;
    align-items: center;
    padding-block-start: 0;
}

.pnl-footer__listitem {
    .pnl-footer--general & {
        flex: 1;

        @media (min-width: 48em) {
            margin-block-end: 2px;
        }
    }

    .pnl-footer--legal & {
        margin-inline-end: 1.5em;

        &:first-child {
            margin: 0 0 1em;
        }

        @media (max-width: 47.9375em) {
            &:nth-child(1) {
                flex-basis: 100%;
            }
        }

        @media (min-width: 48em) {
            margin-inline-end: 0;
            margin-inline-start: 1.5em;

            &:first-child {
                margin-inline-end: auto;
                margin-block-end: 0;
            }
        }
    }
}

.pnl-footer__link {
    border-bottom: 1px solid transparent;
    border-radius: 0.25em;
    font-size: 0.875em;
    font-weight: 400;
    line-height: 150%;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }

    .pnl-footer__list--general & {
        display: flex;
        align-items: center;
        gap: 0.5em;
        color: $color-text-button-secondary-default;
    }

    .pnl-footer__list--legal & {
        display: flex;
        align-items: center;
        gap: 1em;
        color: $color-body-text-default;
        font-size: 0.875em;
        font-weight: normal;
    }

    &:focus:not(:focus-visible) {
        outline: none;
    }

    &:focus-visible {
        outline-color: $color-border-focus-outline;
        outline-style: solid;
        outline-width: 2px;
        outline-offset: 3px;
    }
}

.pnl-footer__image {
    display: inline;
    position: relative;
    vertical-align: middle;

    .pnl-footer--legal & {
        block-size: 40px;
        inline-size: 40px;
    }
}
